/* eslint-disable */ // WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const cognitoQaConfig = {
    aws_project_region: 'ap-south-1',
    // TODO
    aws_cognito_identity_pool_id: 'ap-south-1:aea045a2-ad78-468b-b814-53ea9b28223c',
    aws_cognito_region: 'ap-south-1',
    aws_user_pools_id: 'ap-south-1_iZB7m4HoL',
    aws_user_pools_web_client_id: '7agflnhh6nukqc14sn2gmalugc',
    oauth: {},
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    aws_cloud_logic_custom: [
        {
            name: 'klaviyoapi',
            endpoint: 'https://yl0wr8cvy1.execute-api.ap-south-1.amazonaws.com/dev',
            region: 'ap-south-1'
        },
        {
            name: 'ordersapi',
            endpoint: 'https://sh45e3gzgf.execute-api.ap-south-1.amazonaws.com/dev',
            region: 'ap-south-1'
        }
    ]
};

export { cognitoQaConfig as default };
//# sourceMappingURL=aws-exports-qa.js.map
